import React from 'react';
import { FormControl, FormControlLabel, Checkbox, InputLabel, MenuItem } from '@mui/material';
import { LightTooltip } from '../custom-components/custom-tooltip';

const ServicesSection = ({ formik, onFieldBlur }) => {
  const services = [
    'Revenue Cycle Management (RCM)',
    'Provider Credentialing & Enrollment',
    'Provider-Administered Drug Management (Buy & Bill)',
    'Practice Management Support',
    'Prior Authorization Services',
    'Specialized Services',
  ];

  return (
    <>
      <LightTooltip title="Select the services to be included in this contract.">
        <InputLabel id="services-label">Services</InputLabel>
      </LightTooltip>
      <FormControl>
        {services.map((service) => (
          <MenuItem key={service} value={service}>
            <FormControlLabel
              control={
                <Checkbox
                  name="services"
                  value={service}
                  checked={formik.values.services.includes(service)}
                  onChange={formik.handleChange}
                  onBlur={() => onFieldBlur('services')}
                />
              }
              label={service}
            />
          </MenuItem>
        ))}
      </FormControl>
    </>
  );
};

export default ServicesSection;
